import InputType from "@/services/Input/InputType.js";
import OutputType from "@/services/Input/OutputType.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Date: {
    Label: "Tanggal",
    Type: InputType.Date,
    ReadOnly: true,
    isRange: false,
    Output: OutputType.Date.ShortDate
  },
  Type: {
    Label: "Jenis",
    Type: InputType.Text,
    ReadOnly: true
  },
  Total: {
    Label: "Total",
    Type: InputType.Decimal,
    ReadOnly: true,
    Output: OutputType.Decimal.Accounting2D
  },
}